const Report = () =>
  import(
    /* webpackChunkName: "base-info-car-category" */ '@/pages/base-info/car/category/index.vue'
  )
const Create = () =>
  import(
    /* webpackChunkName: "base-info-car-category" */ '@/pages/base-info/car/category/create.vue'
  )
const Edit = () =>
  import(
    /* webpackChunkName: "base-info-car-category" */ '@/pages/base-info/car/category/edit.vue'
  )

export default {
  path: 'category',
  meta: {
    label: 'carModel',
    auth: 'category'
  },
  component: {
    name: 'Category',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'BaseInfoCarCategory',
      path: '/',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: Report
    },
    {
      name: 'BaseInfoCreateCarCategory',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: Create
    },
    {
      name: 'BaseInfoEditCarCategory',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: Edit,
      props: true
    }
  ]
}
